const projectGallery = document.querySelector(".js-project-gallery");

if(projectGallery) {
    var flkty = new Flickity( projectGallery, {
    // options
        cellAlign: 'center',
        contain: false,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true
    });
}